import KarmicCalculator from './KarmicCalculator';
export default KarmicCalculator;
